import { makeAutoObservable } from 'mobx'
import { type ITooltipProps } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { TooltipLink } from 'shared/ui/Tooltip/ui/components/TooltipLink/TooltipLink'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { BillingPath } from 'entities/ExportRouters'

export class TrialContactsLimitTooltipStore {
  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  get trialSubscription() {
    return this._entities.subscriptionStore.trialSubscriptionStore
  }

  get loading() {
    return this.trialSubscription.loading
  }

  init = async () => {
    if (!this._entities.subscriptionStore.isTrial) return

    await this.trialSubscription.init()
  }

  get isCompleted() {
    return this.trialSubscription.isStatusCompleted
  }

  get configTooltip(): ITooltipProps {
    if (this.isAdminOrOwnerRole) {
      return {
        placement: 'top',
        sx: { width: '280px' },
        type: 'description',
        label: this.isCompleted
          ? 'You have reached the limit of 250 contacts on Trial plan. Upgrade to remove the limits.'
          : 'You have reached the limit of 250 contacts on Trial plan. Get approved and upgrade to remove the limits.',
        desc: this.isCompleted ? (
          <TooltipLink
            text={'Upgrade'}
            onClick={() => {
              uiStore.changeRouteViaVue({
                path: `/${BillingPath.upgrade}`,
              })
            }}
          />
        ) : (
          <TooltipLink
            text={'Get approved'}
            onClick={() => {
              uiStore.changeRouteViaVue({
                path: '/settings/organization/compliance',
              })
            }}
          />
        ),
      }
    }

    return {
      placement: 'top',
      sx: { width: '280px' },
      type: 'description',
      label: this.isCompleted
        ? 'You have reached the limit of 250 contacts on Trial plan. To remove the limits, please ask one of your admins to upgrade.'
        : 'You have reached the limit of 250 contacts on Trial plan. To remove the limits, please ask one of your admins to get approved and upgrade.',
    }
  }

  get isAdminOrOwnerRole() {
    return this._entities.usersStore.user?.isAdminOrOwnerRole
  }

  get hide() {
    return this.loading
  }

  get isTrial() {
    return this._entities.subscriptionStore.isTrial
  }
}
